import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function OccupancySummary({ data }) {
    const navigate = useNavigate();

    // Extract actual API data with zero-safe defaults
    const rate = data?.rate !== undefined && data?.rate !== null ? Number(data.rate) : 0;
    const trend = data?.trend || 'up';
    const isUp = trend === 'up';
    const trendValue = data?.trendValue !== undefined && data?.trendValue !== null ? Number(data.trendValue) : 0;
    const occupied = data?.occupied !== undefined && data?.occupied !== null ? Number(data.occupied) : 0;
    const total = data?.total !== undefined && data?.total !== null ? Number(data.total) : 0;
    const arrivals = data?.arrivals !== undefined && data?.arrivals !== null ? Number(data.arrivals) : 0;
    const pendingCheckins = data?.pendingCheckins !== undefined && data?.pendingCheckins !== null ? Number(data.pendingCheckins) : 0;

    return (
        <Card sx={{ 
            borderRadius: 3, 
            boxShadow: '0 1px 3px rgba(0,0,0,0.04)', 
            border: '1px solid #f1f5f9',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
        }}>
            <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
                {/* Top Label & Badge */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                    <Typography 
                        variant="caption" 
                        sx={{ 
                            fontWeight: 700, 
                            letterSpacing: '0.06em', 
                            color: '#94a3b8', 
                            textTransform: 'uppercase',
                            fontSize: '0.72rem'
                        }}
                    >
                        OCCUPANCY
                    </Typography>
                    <Box 
                        sx={{ 
                            bgcolor: isUp ? '#dcfce7' : '#fee2e2', 
                            color: isUp ? '#16a34a' : '#ef4444', 
                            px: 1, 
                            py: 0.25, 
                            borderRadius: '12px',
                            fontSize: '0.72rem',
                            fontWeight: 700,
                            lineHeight: 1.2
                        }}
                    >
                        {isUp ? `+${trendValue}%` : `-${trendValue}%`}
                    </Box>
                </Box>

                {/* Main Occupancy Value & Rooms Count */}
                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, mb: 2.5 }}>
                    <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a', lineHeight: 1.1, fontSize: '1.85rem' }}>
                        {rate}%
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#94a3b8', fontSize: '0.78rem' }}>
                        {occupied} / {total} rooms
                    </Typography>
                </Box>

                {/* Bottom Row: Arrivals & Pending Check-ins Badge */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', pt: 0.5 }}>
                    <Box>
                        <Typography variant="body1" sx={{ fontWeight: 800, color: '#0f172a', lineHeight: 1.2, fontSize: '0.95rem' }}>
                            {arrivals}
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#94a3b8', fontSize: '0.72rem' }}>
                            Arrivals
                        </Typography>
                    </Box>

                    <Box 
                        onClick={() => navigate('/reservations')}
                        sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: 0.75, 
                            bgcolor: '#fef3c7', 
                            color: '#d97706', 
                            px: 1.25, 
                            py: 0.4, 
                            borderRadius: '10px',
                            cursor: 'pointer',
                            fontSize: '0.72rem',
                            fontWeight: 700,
                            transition: 'all 0.2s',
                            '&:hover': { bgcolor: '#fde68a' }
                        }}
                    >
                        <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#d97706' }} />
                        <span>{pendingCheckins} Pending Check-ins</span>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
}
